const drawerSectionId = document.querySelector('cart-drawer').dataset.id;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (typeof window.sortCartItemsByPrice === 'function') window.sortCartItemsByPrice();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: drawerSectionId,
        selector: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: drawerSectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(function setupCartItemPriceSort() {
  function readPrice(item) {
    const fromData = parseInt(item.dataset.finalPrice, 10);
    if (!isNaN(fromData)) return fromData;
    const priceEl = item.querySelector('.cart-item__price-wrapper');
    if (!priceEl) return Number.MAX_SAFE_INTEGER;
    const matches = (priceEl.textContent || '').match(/[\d,]+\.\d{2}|\d+/g);
    if (!matches || matches.length === 0) return Number.MAX_SAFE_INTEGER;
    const lastMatch = matches[matches.length - 1].replace(/,/g, '');
    const value = parseFloat(lastMatch);
    return isNaN(value) ? Number.MAX_SAFE_INTEGER : Math.round(value * 100);
  }

  function sortContainer(container) {
    if (!container) return;
    const items = Array.from(container.children).filter((el) => el.classList && el.classList.contains('cart-item'));
    if (items.length < 2) return;
    const sorted = items.slice().sort((a, b) => readPrice(a) - readPrice(b));
    if (sorted.every((item, i) => item === items[i])) return;
    const frag = document.createDocumentFragment();
    sorted.forEach((item) => frag.appendChild(item));
    container.appendChild(frag);
  }

  function sortAll() {
    const parents = new Set();
    document.querySelectorAll('.cart-item').forEach((item) => {
      const parent = item.parentElement;
      if (!parent) return;
      if (parent.closest('cart-notification, #cart-notification, #cart-notification-product')) return;
      parents.add(parent);
    });
    parents.forEach(sortContainer);
  }

  window.sortCartItemsByPrice = sortAll;

  const observer = new MutationObserver(sortAll);

  function observeRoot(root) {
    if (!root) return;
    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    sortAll();
    observeRoot(document.querySelector('cart-drawer'));
    observeRoot(document.getElementById('main-cart-items'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
